import React, { useState } from "react";
import axios from "axios";
import "../styles/CreateInvoice.css"; // Reuse existing styles or create a new CSS file

const ItemMapping = () => {
  const [formData, setFormData] = useState({
    amazonSku: "",
    erpItemCode: "",
    meeshoSku: "",
    flipkartSku:"",
    packOf: 0,
    taxRate: 0,
  });

  const [status, setStatus] = useState({ message: "", type: "" }); // For success/error messages

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      setStatus({ message: "Adding item mapping...", type: "info" });

      const response = await axios.post(
        "https://erpnext.api.esoftech.com/api/ExcelImport/InsertItemMapping",
       // "http://localhost:5131/api/ExcelImport/InsertItemMapping",
        formData,
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      if (response.status === 200) {
        setStatus({
          message: "Item mapping added successfully!",
          type: "success",
        });
        // Clear the form after successful submission
        setFormData({
          amazonSku: "",
          erpItemCode: "",
          meeshoSku: "",
          flipkartSku:"",
          packOf: 0,
          taxRate: 0,
        });
      } else {
        setStatus({
          message: "Failed to add item mapping. Please try again.",
          type: "error",
        });
      }
    } catch (error) {
      console.error("Error adding item mapping:", error);
      setStatus({
        message: "An error occurred while adding the item mapping. Please check the details.",
        type: "error",
      });
    }
  };

  return (
    <div className="container">
      <h1 className="title">Add Item Mapping</h1>
      <form onSubmit={handleSubmit} className="upload-section">
        {/* Amazon SKU */}
        <div className="form-group">
          <label>Amazon SKU</label>
          <input
            type="text"
            name="amazonSku"
            value={formData.amazonSku}
            onChange={handleChange}
            placeholder="002_AG"
            required
          />
        </div>

        {/* ERP Item Code */}
        <div className="form-group">
          <label>ERP Item Code</label>
          <input
            type="text"
            name="erpItemCode"
            value={formData.erpItemCode}
            onChange={handleChange}
            placeholder="100070"
            required
          />
        </div>

        {/* Meesho SKU */}
        <div className="form-group">
          <label>Meesho SKU</label>
          <input
            type="text"
            name="meeshoSku"
            value={formData.meeshoSku}
            onChange={handleChange}
            placeholder="XNJxUn6I"
            required
          />
        </div> 
        {/* Flipkart SKU */}
        <div className="form-group">
          <label>Flipkart SKU</label>
          <input
            type="text"
            name="flipkartSku"
            value={formData.flipkartSku}
            onChange={handleChange}
            placeholder="Xnhklmm"
            required
          />
        </div> 

        {/* Pack Of */}
        <div className="form-group">
          <label>Pack Of</label>
          <input
            type="number"
            name="packOf"
            value={formData.packOf}
            onChange={handleChange}
            placeholder="1"
            required
          />
        </div>

        {/* Tax Rate */}
        <div className="form-group">
          <label>Tax Rate</label>
          <input
            type="number"
            name="taxRate"
            value={formData.taxRate}
            onChange={handleChange}
            placeholder="0/5/18"
            required
          />
        </div>

        {/* Submit Button */}
        <button type="submit" className="action-button">
          Add Item Mapping
        </button>

        {/* Status Message */}
        {status.message && (
          <p className={`status ${status.type}`}>{status.message}</p>
        )}
      </form>
    </div>
  );
};

export default ItemMapping;